import {
  MemberPromotionDrawerContext,
  MemberTransactionsTableContext,
  useMemberTransactions
} from '@bo-hooks/members';
import {
  MemberTransactionFilters,
  MemberTransactionsTable
} from '@bo-components/members/memberTransactions';
import { MemberEntryDetails } from '@bo-components/members/entries';
import { MemberPromotionDrawer } from '@bo-components/members/memberPromotions';

export const MemberTransactions = () => {
  const {
    currentPage,
    memberPromotionDrawerContext,
    memberTransactionsTableContext,
    memberTransactionFilters,
    memberTransactionTypeOptions,
    onChangeMemberTransactionsFilter,
    onCloseEntryDetailsModal,
    onCurrentPageChange,
    onResetMemberTransactionFilters,
    selectedEntryId
  } = useMemberTransactions();

  const { memberId, promotionId } = memberPromotionDrawerContext;

  return (
    <div className="w-full px-6 pt-0">
      <MemberTransactionFilters
        memberTransactionFilters={memberTransactionFilters}
        onChangeMemberTransactionsFilter={onChangeMemberTransactionsFilter}
        onResetMemberTransactionFilters={onResetMemberTransactionFilters}
        transactionTypeOptions={memberTransactionTypeOptions}
      />
      <MemberTransactionsTableContext.Provider
        value={memberTransactionsTableContext}
      >
        <MemberTransactionsTable
          currentPage={currentPage}
          memberTransactionFilters={memberTransactionFilters}
          onCurrentPageChange={onCurrentPageChange}
        />
      </MemberTransactionsTableContext.Provider>
      {promotionId && (
        <MemberPromotionDrawerContext.Provider
          value={memberPromotionDrawerContext}
        >
          <MemberPromotionDrawer />
        </MemberPromotionDrawerContext.Provider>
      )}
      {selectedEntryId && (
        <MemberEntryDetails
          entryId={selectedEntryId}
          memberId={memberId}
          onClose={onCloseEntryDetailsModal}
        />
      )}
    </div>
  );
};
